
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center">{{ mailInfo.title }}</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row dense class="pa-2">
                    <v-col cols="3">Type</v-col>
                    <v-col cols="9">{{ mailInfo.prip_type }}</v-col>
                    <v-col cols="3">Description</v-col>
                    <v-col cols="9">{{ mailInfo.prip_oms }}</v-col>
                    <v-col cols="3" v-if="mailInfo.mail_send === ''">Mail send</v-col>
                    <v-col cols="9" v-if="mailInfo.mail_send === ''">{{ mailInfo.mail_send }}</v-col>
                </v-row>
                <v-divider/>
                <v-row dense class="pa-2">
                    <v-col cols="3">Hosts</v-col>
                    <v-col cols="9">{{ mailInfo.eigns }}</v-col>
                    <v-col cols="3" v-if="mailInfo.eigns_send > 0">Responded</v-col>
                    <v-col cols="9" v-if="mailInfo.eigns_send > 0">{{ mailInfo.eigns_response }}</v-col>
                    <v-col cols="3" v-if="mailInfo.eigns_send > 0">No response</v-col>
                    <v-col cols="9" v-if="mailInfo.eigns_send > 0">{{ mailInfo.eigns_no_response }}</v-col>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="success" :disabled="mailInfo.eigns_send > 0||mailInfo.eigns===0" @click="sendEmail">Send</v-btn>
                <v-btn color="primary" @click="closePripEmail">Close</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                mailInfo : {
                    title: "",
                    prip_nr: 0,
                    mltp_nr: 0,
                    mail_send: ""
                },
            }  
        },
        methods: {
            sendPripMail(prip_nr, mltp_nr) {
                this.$axios.post("ares/json/ares/syst/prip/getPripEmail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPripEmail"
                    },
                    getPripEmail: {
                        prip_nr: prip_nr,
                        mltp_nr: mltp_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.mailInfo = res.data.getPripEmail;
                        this.dialog = true;
                    }
                });
            },
            sendEmail() {
                this.$axios.post("ares/json/ares/syst/prip/sendPripEmail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendPripEmail"
                    },
                    sendPripEmail: {
                        prip_nr: this.mailInfo.prip_nr,
                        mltp_nr: this.mailInfo.mltp_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.sendPripEmail.text,
                            color: res.data.sendPripEmail.color
                        });
                        if (res.data.sendPripEmail.color === "success") {
                            this.$emit("reload")
                            this.closePripEmail()
                        }
                    }
                });
            },
            closePripEmail() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
</style>